var _rect, _path, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuMsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.535156,
    y: 0.000488281,
    width: 120.056,
    height: 120.056,
    rx: 32.7425,
    fill: "#38D15A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4645 28.8682C67.4805 28.8682 67.5123 28.8682 67.5601 28.8682C83.6798 28.8682 96.7891 41.9773 96.7891 58.0969C96.7891 64.6754 94.5431 71.0627 90.4336 76.2076L94.6865 86.0992C95.0369 86.9115 94.6546 87.8513 93.8582 88.1858C93.5715 88.3132 93.2529 88.3451 92.9503 88.2973L77.3562 85.5576C74.2342 86.6885 70.9529 87.2619 67.6397 87.246C51.52 87.246 38.4108 74.1369 38.4108 58.0173C38.3789 41.9454 51.3926 28.8841 67.4645 28.8682ZM77.4677 52.2193H68.8662C67.9902 52.2193 67.2734 52.9361 67.2734 53.8122C67.2734 54.6882 67.9902 55.405 68.8662 55.405H77.4677C78.3438 55.405 79.0605 54.6882 79.0605 53.8122C79.0605 52.9361 78.3438 52.2193 77.4677 52.2193ZM57.7162 63.3692H77.4677C78.3438 63.3692 79.0605 62.6525 79.0605 61.7764C79.0605 60.9003 78.3438 60.1835 77.4677 60.1835H57.7162C56.8402 60.1835 56.1234 60.9003 56.1234 61.7764C56.1234 62.6525 56.8402 63.3692 57.7162 63.3692Z",
    fill: "#B6F5C8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.0063,
    cy: 63.8833,
    r: 18.0708,
    fill: "#38D15A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2017_6772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1427 34.1582C54.1267 34.1582 54.0949 34.1582 54.0471 34.1582C37.9275 34.1582 24.8184 47.2673 24.8184 63.387C24.8184 69.9654 27.0643 76.3527 31.1738 81.4976L26.9209 91.3892C26.5705 92.2016 26.9528 93.1413 27.7492 93.4758C28.0359 93.6033 28.3545 93.6351 28.6571 93.5873L44.2511 90.8476C47.3731 91.9786 50.6543 92.552 53.9675 92.5361C70.0871 92.5361 83.1962 79.4269 83.1962 63.3073C83.2281 47.2355 70.2145 34.1741 54.1427 34.1582ZM44.1396 57.5093H52.741C53.617 57.5093 54.3338 58.2261 54.3338 59.1022C54.3338 59.9783 53.617 60.695 52.741 60.695H44.1396C43.2635 60.695 42.5467 59.9783 42.5467 59.1022C42.5467 58.2261 43.2635 57.5093 44.1396 57.5093ZM63.8909 68.6593H44.1396C43.2635 68.6593 42.5467 67.9425 42.5467 67.0664C42.5467 66.1904 43.2635 65.4736 44.1396 65.4736H63.8909C64.767 65.4736 65.4837 66.1904 65.4837 67.0664C65.4837 67.9425 64.767 68.6593 63.8909 68.6593Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2017_6772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.4501,
    height: 59.4502,
    fill: "white",
    transform: "translate(24.2812 34.1572)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuMsgIcon);
export default __webpack_public_path__ + "static/media/zunu_msg_icon.a0bd829fb60c15aba9f82518593e9a99.svg";
export { ForwardRef as ReactComponent };